import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Element, { Message } from 'element-ui'
import '@/styles/main.scss'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.css'
import echarts from 'echarts'
import eventBus from '@/javascripts/event-bus'
import * as filters from './filters'
import jwt from 'jsonwebtoken'
import api from './apis/apis'

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$jwt = jwt
Vue.use(Element)
Vue.use(eventBus)

console.log('当前版本: 4.0.0')

// register common filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

/** 根据后端结果返回的处理
 *  res后端返回
 *  message前端操作的信息提示
 *  successCb成功回调
 *  errorCb失败回调
 */
Vue.prototype.handleResult = (res, message, successCb, errorCb) => {
  const { errCode, msg } = res
  if (errCode === 0 && message === '') {
    successCb && successCb()
    return false
  } else if (errCode === 0) {
    Message({ message: message + '成功! ' || '操作成功!', type: 'success', duration: 2000 })
    successCb && successCb()
  } else {
    Message({ message: message + '失败! ' + msg || '操作失败', type: 'error', duration: 2000 })
    errorCb && errorCb()
  }
}

api.getConfig().then(res => {
  const constantConfig = {
    pageSize: 15,
    SIZE_OF_INPUTBOX: 'small'
  }
  Vue.prototype.GLOBAL = Object.assign(constantConfig, res.data)
}).finally(() => {
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
})
